import angular from 'angular';

angular.module('neurotecAbisWebClientApp')
	.directive('alerts', () => ({
		template: require('../../../views/directives/admin/alerts.html'),
		restrict: 'E',
		replace: true,
		scope: {
			alerts: '='
		}
	}));
